import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const getEmail = createSelector(getData, (data) => {
  return get(data, "email", "");
});
